import { PortfolioItemSelectStep } from '../PortfolioItemSelectStep';
import mappedItemTypes from 'services/items/mappedItemTypes';
import { PCW_STEPS } from '../constants';

export function LoadStep() {
    return <PortfolioItemSelectStep stepId={PCW_STEPS.PCW_LOAD_STEP_ID} itemTypeIds={[mappedItemTypes.LOAD.id]} />;
}
